// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mandatory-label[data-v-372dde45]{text-align:left;padding-bottom:0;font-size:12px;line-height:12px;color:#666}", ""]);
// Exports
module.exports = exports;
